
import Vue from 'vue'

const Hub = new Vue();

export default Hub;